module.exports = __webpack_public_path__ + "static/media/BlackArrow.470b6adf.svg";